import { render, staticRenderFns } from "./shopLicenceAdd.vue?vue&type=template&id=7f623c10&"
import script from "./shopLicenceAdd.vue?vue&type=script&lang=js&"
export * from "./shopLicenceAdd.vue?vue&type=script&lang=js&"
import style0 from "./shopLicenceAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports